// ==========================================================================
// Form Upload
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

import {
    toggleAttributeValue,
    removeAttributeValue,
    wrapAll
} from 'groots/utilities';

class GrFormUpload {
    constructor(selector) {
        this.pluginName = 'grFormUpload';

        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        this.init();
    }

    //  Methods
    // ----------------------------------------------------------------------

    init() {
        if (this.selector === null) {
            throw new Error(this.pluginName + ': fail - something wrong with your selector');
        } else {
            // Bind all event handlers for referencability
            var arr = ['changeHandler'];

            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }

            window.addEventListener('change', this.changeHandler);

            this.build();

            toggleAttributeValue(this.selector, 'gr-form-upload', 'ready');

            if (window.groots.verbose) {
                console.warn(this.pluginName + ': ready');
            }
        }
    }

    build() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ': processing');
        }

        toggleAttributeValue(this.selector, 'gr-form-upload', 'processing');

        var fake_label = document.createElement('label');
        var fake_label_inner = document.createElement('span');
        fake_label.appendChild(fake_label_inner);
        fake_label.setAttribute('for', this.selector.id);
        fake_label_inner.innerHTML = this.selector.getAttribute('placeholder') !== null ? this.selector.getAttribute('placeholder') : '';

        var collection = [this.selector, fake_label];
        var wrapper = document.createElement('div');
        wrapper.setAttribute('gr-form', 'upload-wrapper');

        wrapAll(collection, wrapper);

        removeAttributeValue(this.selector, 'gr-form-upload', 'processing');
    }

    changeHandler() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ': changed');
        }

        if (this.selector.value !== '') {
            var filename = this.selector.value.replace(/^.*[\\\/]/, '');
            this.selector.parentNode.querySelector('label span').innerHTML = filename;
        } else {
            this.selector.parentNode.querySelector('label span').innerHTML = this.selector.getAttribute('placeholder') !== null ? this.selector.getAttribute('placeholder') : '';
        }
    }

}

export default GrFormUpload;

//  Auto-Instantiation
// ----------------------------------------------------------------------

(function() {
    const all = document.querySelectorAll('[gr-form] input[type=file]');
    window.groots.plugins.grFormUpload = {};

    if (all.length) {
        window.groots.plugins.grFormUpload.instances = {};
        let index = -1;

        while (all[++index]) {
            window.groots.plugins.grFormUpload.instances[index] = new GrFormUpload(all[index]);
        }
    }
}());
